module.exports = __webpack_public_path__ + "img/ic_feature_nutrition.f9eec7cf.svg";